import classNames from './GettingStartedInstructions.module.scss';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import classes from 'classnames';
import chat from '@/assets/svg/chat.svg';
import rightArrow from '@/assets/svg/right-arrow.svg';
import { useDrawer } from '@/context/DrawerContext';
import { useAppSelector } from '@/store';
import { authSelector, interfaceLanguageSelector } from '@/store/reducers/auth';
import UserUtils from '@/utils/user';

interface GettingStartedInstructionsProps {
  isCollapsed?: boolean;
}

const GettingStartedInstructions = ({ isCollapsed }: GettingStartedInstructionsProps) => {
  const { t } = useTranslation();
  const drawer = useDrawer();
  const interfaceLanguage = useAppSelector(interfaceLanguageSelector);
  const { nativeLanguage, user } = useAppSelector(authSelector);

  const isTeacher = UserUtils.isTeacher(user);
  const isInterfaceLangHE = interfaceLanguage?.code === 'he';
  const isNativeLanguageHEAndInterfaceEN =
    nativeLanguage === 'he' && interfaceLanguage?.code === 'en';
  const isRtl = interfaceLanguage?.direction === 'rtl';

  if (!isTeacher) return null;

  return (
    <div
      className={classes(classNames.gettingStartedInstructions, {
        [classNames.collapsed]: isCollapsed,
      })}
    >
      <div className={classNames.help}>
        <img
          className={classes(classNames.chat, {
            [classNames.chatSvgRtl]: isRtl,
          })}
          src={chat}
        />
        <div className={classNames.helpContent}>
          <h2>{t('needHelp')}</h2>
          <p>
            {isNativeLanguageHEAndInterfaceEN ? (
              <span>{t('contactOurTeamWithQuestions')}</span>
            ) : (
              <>
                <span>{t('contactOurTeam')}</span>
                <span>{t('britannicaEducationWith')}</span>
                {!isInterfaceLangHE && <span>{t('questionsAndConcerns')}</span>}
              </>
            )}
          </p>
          <button className={classNames.feedbackBtn} onClick={drawer.openContactUsDrawer}>
            {t('giveFeedback')}
            <SVG
              className={classes(classNames.arrow, {
                [classNames.arrowSvgRtl]: isRtl,
              })}
              src={rightArrow}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GettingStartedInstructions;
